export const CREATE_PRINT_QR_START = "CREATE_PRINT_QR_START";
export const CREATE_PRINT_QR_SUCCESS = "CREATE_PRINT_QR_SUCCESS";
export const CREATE_PRINT_QR_FAILURE = "CREATE_PRINT_QR_FAILURE";

export const GET_PRINT_QR_LIST_START = "GET_PRINT_QR_LIST_START";
export const GET_PRINT_QR_LIST_SUCCESS = "GET_PRINT_QR_LIST_SUCCESS";
export const GET_PRINT_QR_LIST_FAILURE = "GET_PRINT_QR_LIST_FAILURE";